import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Spacing } from '@constants/spacing';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    label: string;
    children: ReactNode;
    color?: string;
    spacing?: Spacing;
    align?: 'center' | 'flex-start';
}

function GiftInfoRow({
    label, children, color = colors.textSecondary, spacing = 2, align = 'center',
}: Props) {
    return (
        <Row spacing={spacing} align={align} fullWidth justify='space-between'>
            <Label size='body-short' as='dt' color={colors.textSecondary}>{label}</Label>
            <Value size='body-short' as='dd' color={color} align='right'>{children}</Value>
        </Row>
    );
}

const Label = styled(Text)`
    flex-shrink: 0;
`;

const Value = styled(Text)`
    word-break: break-word;
`;

export default GiftInfoRow;
